<template>
  <loader v-if="fetchJobPending && Object.keys(jobItem).length === 0"/>
  <v-container v-else>
    <v-row>
      <v-col :cols="12" class="d-flex justify-space-between">
        <div class="d-flex align-center">
          <v-btn text icon @click="() => $router.go(-1)">
            <v-icon>chevron_left</v-icon>
          </v-btn>
          <h1>{{ jobItem.title }}</h1>
        </div>
        <div v-if="!maintenanceActive" class="d-flex">
          <favorite-button :item="jobItem" :light="false"/>
          <application-button :job="jobItem" :light="false"/>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col :cols="12" :md="7">
                  <p>{{ $t('texts.publishedOm') }}: {{ jobItem.updated_at | formatUnixTimestampMedium }}</p>
                  <div v-html="jobItem.introduction"></div>
                  <h2>
                    {{ jobItem.title }}
                    (<span v-if="jobItem.workload_min === 100">{{ jobItem.workload_min }}%</span>
                    <span v-else-if="jobItem.workload_min >= jobItem.workload_max">{{ jobItem.workload_min }}%</span>
                    <span v-else>{{ jobItem.workload_min }} - {{ jobItem.workload_max }}%</span>)
                  </h2>
                  <p>
                    {{ $t('texts.months.'+[jobItem.start_month]) }} {{ jobItem.start_year }} -
                    {{ $t('texts.months.'+[jobItem.end_month]) }} {{ jobItem.end_year }}
                    <span v-if="jobItem.place !== '' && jobItem.place !== null">({{ jobItem.place }})</span>
                    <br />
                  </p>
                  <div class="quill__text" v-html="jobItem.description"></div>
                </v-col>
                <v-col :cols="12" :md="4" :offset-md="1">
                  <img :src="`${fileHost}/companies/${company.id}/images/standard.png?${today}`" width="100%">
                  <p>
                    <strong>{{ company.name }}</strong><br>
                    {{ company.street }} {{ company.street_number }}<br>
                    {{ company.zip }} {{ company.place }}<br>
                    {{ company.phone }}<br>
                    <a v-bind:href="companyWebsite" target="_blank">{{ companyWebsite }}</a>
                  </p>
                  <p v-if="jobItem.accommodation">
                    {{ $t('texts.lodging') }}
                  </p>
                  <map-component
                    v-if="coordinates[0].lat && coordinates[0].lng"
                    :mapName="`map-job-${jobItem.id}`"
                    :markers="coordinates"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider/>
          <v-card-actions class="py-3 px-5">
            <v-spacer/>
            <favorite-button favoriteType="job" :item="jobItem"/>
            <application-button :job="jobItem" :company="company" />
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from 'moment';
import { createNamespacedHelpers } from 'vuex';
import { fileHost } from '@/config';
import MapComponent from '@/components/_organisms/MapComponent.vue';
import ApplicationButton from './ApplicationButton.vue';
import FavoriteButton from './FavoriteButton.vue';

const { mapState: mapUserState } = createNamespacedHelpers('user');
const { mapState: mapGeneralState, mapActions: mapGeneralActions } = createNamespacedHelpers('general');

export default {
  name: 'jobDetail',
  components: {
    ApplicationButton,
    MapComponent,
    FavoriteButton,
  },
  data() {
    return {
      jobItem: {},
      company: {},
      fileHost,
    };
  },
  created() {
    if (this.$route.params.job) {
      Object.assign(this.jobItem, this.$route.params.job);
      Object.assign(this.company, this.$route.params.company);
    } else {
      this.fetchJob(this.$route.params.id).then((response) => {
        this.jobItem = { ...response };
        this.company = { ...response.company };
      });
    }
  },
  computed: {
    ...mapUserState([
      'maintenanceActive',
    ]),
    ...mapGeneralState([
      'job',
      'fetchJobPending',
    ]),
    today() {
      return moment().format('YYYYMMDD');
    },
    coordinates() {
      const coordinates = [{
        lat: this.jobItem.latitude > 0 ? parseFloat(this.jobItem.latitude) : 0,
        lng: this.jobItem.longitude > 0 ? parseFloat(this.jobItem.longitude) : 0,
      }];
      return coordinates;
    },
    companyWebsite() {
      let url = this.company.website;
      if (url) {
        if (!/^(f|ht)tps?:\/\//i.test(url)) {
          url = `http://${url}`;
        }
        return url;
      }
      return '';
    },
  },
  methods: {
    ...mapGeneralActions([
      'fetchJob',
    ]),
  },
};
</script>
